(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["flamengo-cart-line-image"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('flamengo-cart-image')) {
    customElements.define('flamengo-cart-image', class extends HTMLElement {
      connectedCallback() {
        const apply = () => {
          const script = this.querySelector('[data-line-image]');
          if (!script) return;
          let data;
          try { data = JSON.parse(script.textContent); } catch (_) { return; }
          if (!data.color) return;
          const map = data.map || {};
          let mediaId = Number(data.nativeMedia) || 0;
          const correction = map.__nativeOverrides?.[data.color];
          if (Array.isArray(map.__missingColors) && map.__missingColors.includes(data.color)) {
            mediaId = 0;
          } else if (mediaId && correction && Array.isArray(correction.from) && correction.from.some(id => Number(id) === mediaId)) {
            mediaId = Number(correction.to) || 0;
          } else if (!mediaId) {
            mediaId = Number(map[data.color]) || 0;
          }
          const chosen = data.images?.[String(mediaId)];
          const img = this.querySelector('img');
          const missing = this.querySelector('.flamengo-cart-line-image__missing');
          const note = this.querySelector('.flamengo-cart-line-image__note');
          const source = chosen?.src ? chosen : data.fallback;
          const isFallback = !chosen?.src;
          this.dataset.fallback = String(isFallback);
          if (img && source?.src) {
            img.src = source.src;
            img.alt = source.alt || '';
            img.hidden = false;
            if (missing) missing.hidden = true;
            if (note) note.hidden = !isFallback;
          } else {
            if (img) img.hidden = true;
            if (missing) missing.hidden = false;
            if (note) note.hidden = true;
          }
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply, { once: true });
        else apply();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["flamengo-cart-polish"] && !Shopify.designMode) return;
  try {
    customElements.whenDefined('cart-drawer-items').then(() => {
    const prototype = customElements.get('cart-drawer-items').prototype;
    if (prototype.flamengoQuantityReady) return;
    prototype.flamengoQuantityReady = true;
    document.addEventListener('change', (event) => {
      const input = event.target;
      if (!input.matches('.quantity__input[data-index]')) return;
      const items = input.closest('cart-drawer-items');
      if (!items) return;
      event.stopPropagation();
      items.onChange(event);
    }, true);

    prototype.onChange = function (event) {
      const input = event.target;
      if (!input.matches('.quantity__input[data-index]')) return;
      const quantity = input.value.trim() === '' ? NaN : Number(input.value);
      const min = Number(input.dataset.min) || 1;
      const max = input.max === '' ? Infinity : Number(input.max);
      const step = Number(input.step) || 1;
      if (!Number.isSafeInteger(quantity) || quantity < 0 || quantity > max || quantity !== 0 && (quantity < min || quantity % step !== 0)) {
        input.value = input.defaultValue;
        input.setAttribute('aria-invalid', 'true');
        const error = this.querySelector(`#CartDrawer-LineItemError-${input.dataset.index} .cart-item__error-text`);
        if (error) error.textContent = input.dataset.quantityError;
        input.focus({ preventScroll: true });
        return;
      }
      input.removeAttribute('aria-invalid');
      this.updateQuantity(input.dataset.index, quantity, event, 'updates[]', input.dataset.quantityVariantId);
    };

    prototype.updateQuantity = async function (line, quantity, event, name, variantId) {
      const drawer = this.closest('cart-drawer');
      if (!drawer || drawer.dataset.flamengoUpdating === 'true') return;
      const input = this.querySelector(`#Drawer-quantity-${line}`);
      if (!input || quantity === Number(input.defaultValue)) return;
      const wasOpen = drawer.classList.contains('active');
      const controls = Array.from(drawer.querySelectorAll('button:not(:disabled):not(.drawer__close), input:not(:disabled), select:not(:disabled), textarea:not(:disabled)'));
      const errorText = window.cartStrings?.error || input.dataset.quantityError;
      let changed = false;
      drawer.dataset.flamengoUpdating = 'true';
      drawer.setAttribute('aria-busy', 'true');
      controls.forEach(control => { control.disabled = true; });
      drawer.querySelectorAll('.cart-item__error-text, #CartDrawer-CartErrors').forEach(node => { node.textContent = ''; });
      try {
        const response = await fetch(window.routes.cart_change_url, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: input.dataset.cartLineKey,
            quantity: Number(quantity),
            sections: ['cart-drawer', 'cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        });
        const result = await response.json();
        if (!response.ok || result.status || result.errors) {
          let message = typeof result.errors === 'string' ? result.errors : result.description || result.message || errorText;
          const stockLimit = message.match(/^Only (\d+) items? (?:was|were) added to your cart due to availability\.?$/i);
          if (stockLimit && window.cartStrings?.quantityError) message = window.cartStrings.quantityError.replace('[quantity]', stockLimit[1]);
          throw new Error(message);
        }
        changed = true;
        const html = result.sections?.['cart-drawer'];
        const parsed = html && new DOMParser().parseFromString(html, 'text/html');
        const newInner = parsed && parsed.querySelector('.drawer__inner');
        if (!newInner) {
          window.location.assign(window.routes.cart_url);
          return;
        }
        drawer.querySelector('.drawer__inner').replaceWith(newInner);
        drawer.classList.toggle('is-empty', result.item_count === 0);
        const iconHtml = result.sections?.['cart-icon-bubble'];
        if (iconHtml) {
          const icon = document.getElementById('cart-icon-bubble');
          const iconSection = new DOMParser().parseFromString(iconHtml, 'text/html').querySelector('.shopify-section');
          if (icon && iconSection) icon.innerHTML = iconSection.innerHTML;
        }
        const updatedInput = drawer.querySelector(`#Drawer-quantity-${line}`);
        const actual = quantity > 0 && result.items[Number(line) - 1]?.quantity;
        if (quantity > 0 && actual !== Number(quantity)) {
          const error = drawer.querySelector(`#CartDrawer-LineItemError-${line} .cart-item__error-text`);
          if (error) error.textContent = window.cartStrings?.quantityError?.replace('[quantity]', actual) || errorText;
        }
        if (wasOpen && drawer.classList.contains('active')) {
          const target = quantity > 0 && updatedInput || drawer.querySelector('.drawer__close');
          if (typeof trapFocus === 'function') trapFocus(drawer.querySelector('.drawer__inner'), target);
          else target?.focus({ preventScroll: true });
        }
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'cart-items', cart: result } }));
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: result, variantId: variantId });
        }
      } catch (error) {
        if (changed) {
          window.location.assign(window.routes.cart_url);
          return;
        }
        input.value = input.defaultValue;
        const lineError = drawer.querySelector(`#CartDrawer-LineItemError-${line} .cart-item__error-text`);
        const errorNode = lineError || drawer.querySelector('#CartDrawer-CartErrors');
        if (errorNode) errorNode.textContent = error.message || errorText;
      } finally {
        controls.forEach(control => { control.disabled = false; });
        drawer.dataset.flamengoUpdating = 'false';
        drawer.removeAttribute('aria-busy');
        if (!changed && wasOpen && drawer.classList.contains('active')) input.focus({ preventScroll: true });
      }
    };
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["flamengo-cart-recommendations"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('flamengo-cart-recommendations')) {
    customElements.define('flamengo-cart-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.querySelectorAll('[data-fcr-image]').forEach((img) => {
          img.dataset.fallbackSrc = img.getAttribute('src');
          img.dataset.fallbackAlt = img.getAttribute('alt') || '';
        });
        this.addEventListener('change', (event) => {
          const select = event.target.closest('[data-fcr-variant]');
          if (select) {
            event.stopPropagation();
            this.selectVariant(select);
          }
        });
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-fcr-add]');
          if (button) {
            event.preventDefault();
            this.addVariant(button);
          }
        });
        this.querySelectorAll('[data-fcr-variant]').forEach((select) => {
          const options = Array.from(select.options).slice(1);
          const rank = (title) => {
            const value = title.split(' / ')[0].trim().toUpperCase();
            const sizes = ['XXXS','XXS','XS','S','M','L','XL','XXL','2XL','XXXL','3XL','4XL','5XL','6XL'];
            return /^\d+(\.\d+)?$/.test(value) ? Number(value) : sizes.indexOf(value) >= 0 ? sizes.indexOf(value) : 1000;
          };
          options.sort((a, b) => rank(a.textContent) - rank(b.textContent));
          options.forEach((option) => select.appendChild(option));
          this.selectVariant(select);
        });
        this.querySelectorAll('[data-fcr-add][data-default-variant]').forEach((button) => { button.disabled = false; });
      }

      selectVariant(select) {
        const card = select.closest('[data-fcr-card]');
        const option = select.selectedOptions[0];
        const button = card.querySelector('[data-fcr-add]');
        button.disabled = this.busy || !select.value;
        button.dataset.variantId = select.value;
        button.dataset.quantity = option?.dataset.quantity || '1';
        if (!select.value) return;
        card.querySelector('[data-fcr-price]').textContent = option.dataset.price;
        card.querySelector('[data-fcr-product-link]').href = option.dataset.url;
        const image = card.querySelector('[data-fcr-image]');
        if (image) {
          let source = { url: option.dataset.image, alt: option.dataset.imageAlt };
          if (card.dataset.hasColor === 'true') {
            let data = { map: {}, images: {} };
            try { data = JSON.parse(card.querySelector('[data-fcr-media]')?.textContent || '{}'); } catch (_) {}
            const map = data.map || {};
            const color = option.dataset.color;
            let mediaId = Number(option.dataset.mediaId);
            if (!mediaId) {
              const sibling = Array.from(select.options).find((candidate) => candidate.dataset.color === color && Number(candidate.dataset.mediaId));
              mediaId = Number(sibling?.dataset.mediaId) || 0;
            }
            const correction = map.__nativeOverrides?.[color];
            if (Array.isArray(map.__missingColors) && map.__missingColors.includes(color)) {
              mediaId = 0;
            } else if (mediaId && correction && Array.isArray(correction.from) && correction.from.some((id) => Number(id) === mediaId)) {
              mediaId = Number(correction.to) || 0;
            } else if (!mediaId) {
              mediaId = Number(map[color]) || 0;
            }
            source = data.images?.[String(mediaId)] || {};
          }
          const fallback = !source.url && card.dataset.hasColor === 'true';
          if (fallback) source = { url: image.dataset.fallbackSrc, alt: image.dataset.fallbackAlt };
          if (source.url) {
            image.src = source.url;
            image.removeAttribute('srcset');
            image.alt = source.alt || '';
            image.hidden = false;
          } else if (card.dataset.hasColor === 'true') {
            image.hidden = true;
          }
          const note = card.querySelector('[data-fcr-image-note]');
          if (note) note.hidden = !fallback;
        }
        this.querySelector('[data-fcr-status]').textContent = '';
      }

      async addVariant(button) {
        if (this.busy || button.disabled || !button.dataset.variantId) return;
        const cartScope = this.closest('cart-drawer') || this.closest('.flamengo-cart');
        if (cartScope?.dataset.flamengoUpdating === 'true' || cartScope?.getAttribute('aria-busy') === 'true') return;
        const controls = Array.from(cartScope?.querySelectorAll('button:not(:disabled):not(.drawer__close), input:not(:disabled), select:not(:disabled)') || []);
        if (cartScope) cartScope.dataset.flamengoUpdating = 'true';
        controls.forEach(control => { control.disabled = true; });
        this.busy = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        button.textContent = this.dataset.adding;
        const status = this.querySelector('[data-fcr-status]');
        status.textContent = '';
        let added = false;
        try {
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [{ id: Number(button.dataset.variantId), quantity: Number(button.dataset.quantity) || 1 }],
              sections: ['cart-drawer', 'cart-icon-bubble'],
              sections_url: window.location.pathname
            })
          });
          const result = await response.json();
          if (!response.ok || result.status) throw new Error(result.description || result.message || this.dataset.error);
          added = true;
          if (this.dataset.context === 'page') {
            window.location.reload();
            return;
          }
          const drawer = document.querySelector('cart-drawer');
          if (!drawer || typeof drawer.renderContents !== 'function' || !result.sections?.['cart-drawer'] || !result.sections?.['cart-icon-bubble']) {
            window.location.assign(this.dataset.cartUrl);
            return;
          }
          drawer.renderContents(result);
          drawer.classList.remove('is-empty');
          const liveStatus = drawer.querySelector('[data-fcr-status]') || drawer.querySelector('#CartDrawer-LiveRegionText');
          if (liveStatus) liveStatus.textContent = this.dataset.added;
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'flamengo-cart-recommendations' } }));
          window.setTimeout(() => {
            const closeButton = drawer.querySelector('.drawer__close');
            closeButton?.focus({ preventScroll: true });
          }, 80);
        } catch (error) {
          if (added) {
            window.location.assign(this.dataset.cartUrl);
            return;
          }
          status.textContent = error.message || this.dataset.error;
          button.disabled = false;
          button.textContent = this.dataset.add;
          button.removeAttribute('aria-busy');
          this.busy = false;
        } finally {
          if (cartScope) cartScope.dataset.flamengoUpdating = 'false';
          if (!added) controls.forEach(control => { control.disabled = false; });
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["flamengo-collection-card-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('flamengo-collection-gallery')) {
  customElements.define('flamengo-collection-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.galleryReady) return;
      this.track = this.querySelector('[data-gallery-track]');
      this.slides = this.querySelectorAll('.flamengo-collection-gallery__slide');
      if (!this.track || this.slides.length < 2) return;
      this.galleryReady = true;
      this.previous = this.querySelector('[data-gallery-previous]');
      this.next = this.querySelector('[data-gallery-next]');
      this.position = this.querySelector('[data-gallery-position]');
      this.currentIndex = 0;
      this.previous.hidden = false;
      this.next.hidden = false;
      this.position.hidden = false;
      this.updatePosition();
      this.previous.addEventListener('click', () => this.move(-1));
      this.next.addEventListener('click', () => this.move(1));
      this.track.addEventListener('scroll', () => {
        if (this.scrollFrame) return;
        this.scrollFrame = requestAnimationFrame(() => {
          this.scrollFrame = null;
          this.updatePosition();
        });
      }, { passive: true });
      this.track.addEventListener('pointerdown', event => {
        this.pointerStart = { x: event.clientX, y: event.clientY };
        this.suppressClick = false;
      }, { passive: true });
      this.track.addEventListener('pointermove', event => {
        if (this.pointerStart && Math.abs(event.clientX - this.pointerStart.x) > 8) this.suppressClick = true;
      }, { passive: true });
      this.track.addEventListener('pointercancel', () => { this.suppressClick = true; this.pointerStart = null; });
      this.track.addEventListener('pointerup', () => { this.pointerStart = null; });
      this.track.addEventListener('click', event => {
        if (this.suppressClick) { event.preventDefault(); event.stopPropagation(); this.suppressClick = false; }
      }, true);
    }
    move(direction) {
      const index = Math.min(this.slides.length - 1, Math.max(0, this.currentIndex + direction));
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: this.track.clientWidth * index, behavior: reducedMotion ? 'auto' : 'smooth' });
    }
    updatePosition() {
      const width = this.track.clientWidth;
      this.currentIndex = width ? Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / width))) : 0;
      this.previous.disabled = this.currentIndex === 0;
      this.next.disabled = this.currentIndex === this.slides.length - 1;
      this.slides.forEach((slide, index) => { slide.tabIndex = index === this.currentIndex ? 0 : -1; });
      this.position.querySelector('[data-gallery-position-visible]').textContent = `${this.currentIndex + 1} / ${this.slides.length}`;
      this.position.querySelector('[data-gallery-position-accessible]').textContent = this.dataset.positionLabel.replace('[current]', this.currentIndex + 1);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["flamengo-unified-colors"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('flamengo-unified-colors')) {
 customElements.define('flamengo-unified-colors', class extends HTMLElement {
  connectedCallback() {
   if (this.ready) return;
   this.ready = true;
   this.root = this.closest('[data-flamengo-collection]');
   if (!this.root) return;
   this.url = new URL(window.location.href);
   this.selection = this.url.searchParams.get('bf_color') || '';
   this.grid = this.root.querySelector('[data-collection-grid]');
   this.group = this.querySelector('.bf-colors__group');
   this.status = this.querySelector('.bf-colors__status');
   this.choices = this.querySelector('.bf-colors__choices');
   this.cards = new Map();
   this.controller = new AbortController();
   this.root.classList.add('is-unified-colors');
   this.group.hidden = false;
   this.status.textContent = this.dataset.loading;
   this.registerCards(this.root);
   const native = Array.from(this.root.querySelectorAll('[data-native-color-active]'));
   if (!this.selection && native.length) {
    const label = native[0].dataset.nativeColorActive;
    const next = this.colorUrl(this.normalize(label));
    window.location.replace(next.href);
    return;
   }
   this.openHandler = event => { if (event.target.closest('[data-open-filters]')) this.load(); };
   this.root.addEventListener('click', this.openHandler);
   if (this.selection) {
    this.selection = this.normalize(this.selection);
    const filterButton = this.root.querySelector('[data-open-filters]');
    if (filterButton) {
     let badge = filterButton.querySelector('.flamengo-collection-pro__filter-count');
     if (!badge) { badge = document.createElement('span'); badge.className = 'flamengo-collection-pro__filter-count'; filterButton.append(badge); }
     badge.textContent = String((Number(badge.textContent.trim()) || 0) + 1);
    }
    this.resultStatus = document.createElement('p');
    this.resultStatus.className = 'bf-colors__result-status';
    this.resultStatus.setAttribute('role', 'status');
    this.resultStatus.textContent = this.dataset.loading;
    const main = this.root.querySelector('.flamengo-collection-pro__main');
    main.prepend(this.resultStatus);
    const active = document.createElement('div');
    active.className = 'bf-colors__active';
    active.textContent = this.dataset.title + ': ' + this.selection;
    const clear = document.createElement('a');
    clear.href = this.colorUrl('').href;
    clear.className = 'bf-colors__clear';
    clear.textContent = this.dataset.clear;
    active.append(clear);
    this.root.querySelector('.flamengo-collection-pro__toolbar').after(active);
    this.root.querySelectorAll('form[method="get"]').forEach(form => {
     const field = document.createElement('input');
     field.type = 'hidden'; field.name = 'bf_color'; field.value = this.selection; form.append(field);
    });
    this.root.addEventListener('click', event => {
     const link = event.target.closest('a[href]');
     if (!link || !link.closest('.flamengo-collection-pro__filter-values, .flamengo-collection-pro__active-filters')) return;
     if (link.classList.contains('flamengo-collection-pro__clear')) return;
     const next = new URL(link.href, window.location.href);
     next.searchParams.set('bf_color', this.selection);
     next.searchParams.delete('page');
     link.href = next.href;
    });
    this.apply(false);
    this.load();
   }
  }
  disconnectedCallback() {
   if (this.root && this.openHandler) this.root.removeEventListener('click', this.openHandler);
   if (this.controller) this.controller.abort();
  }
  normalize(value) {
   const text = String(value).trim().toLowerCase().replace(/[’׳']/g, '');
   const names = {black:'שחור',white:'לבן',blue:'כחול',red:'אדום',green:'ירוק',pink:'ורוד',brown:'חום',beige:'בז',gray:'אפור',grey:'אפור',yellow:'צהוב',orange:'כתום',purple:'סגול',navy:'נייבי',cream:'שמנת',gold:'זהב',silver:'כסף'};
   return names[text] || text;
  }
  colorUrl(value) {
   const next = new URL(this.url);
   Array.from(next.searchParams.keys()).forEach(key => {
    const name = key.toLowerCase();
    if (name.startsWith('filter.v.option.') && (name.includes('צבע') || name.endsWith('.color') || name.endsWith('.colour'))) next.searchParams.delete(key);
   });
   next.searchParams.delete('page');
   next.searchParams.delete('section_id');
   next.searchParams.delete('bf_color');
   if (value) next.searchParams.set('bf_color', value);
   return next;
  }
  registerCards(scope) {
   scope.querySelectorAll('.flamengo-card[data-product-id]').forEach(card => {
    if (this.cards.has(card.dataset.productId)) return;
    let data = [];
    try { data = JSON.parse(card.querySelector('[data-card-color-data]')?.textContent || '[]'); } catch (_) { throw new Error('Invalid color data'); }
    this.cards.set(card.dataset.productId, {card, colors:data.map(color => ({...color, key:this.normalize(color.name)}))});
   });
  }
  async load() {
   if (this.loading || this.loaded) return;
   this.loading = true;
   this.registerCards(this.root);
   this.status.textContent = this.dataset.loading;
   this.querySelector('.bf-colors__retry')?.remove();
   try {
    let link = this.root.querySelector('[data-collection-next]');
    let next = link ? new URL(link.href, window.location.href) : null;
    const visited = new Set();
    while (next) {
     next.searchParams.set('section_id', this.dataset.sectionId);
     ['preview_theme_id','_fd','pb'].forEach(key => { if (this.url.searchParams.has(key)) next.searchParams.set(key, this.url.searchParams.get(key)); });
     if (visited.has(next.href)) throw new Error('Repeated pagination');
     visited.add(next.href);
     const response = await fetch(next.href, {signal:this.controller.signal});
     if (!response.ok) throw new Error('Collection loading failed');
     const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
     const incoming = doc.querySelector('[data-flamengo-collection]');
     if (!incoming) throw new Error('Collection missing');
     this.registerCards(incoming);
     link = incoming.querySelector('[data-collection-next]');
     next = link ? new URL(link.getAttribute('href'), this.url) : null;
    }
    this.loaded = true;
    this.drawChoices();
    if (this.selection) this.apply(true);
   } catch (error) {
    if (error.name === 'AbortError') return;
    this.status.textContent = this.dataset.error;
    if (this.resultStatus) this.resultStatus.textContent = this.dataset.error;
    const retry = document.createElement('button');
    retry.type = 'button'; retry.className = 'bf-colors__retry'; retry.textContent = this.dataset.retry;
    retry.addEventListener('click', () => this.load()); this.status.after(retry);
   } finally { this.loading = false; }
  }
  drawChoices() {
   const colors = new Map();
   this.cards.forEach(entry => {
    const seen = new Set();
    entry.colors.forEach(color => {
     if (seen.has(color.key)) return;
     seen.add(color.key);
     const existing = colors.get(color.key);
     if (existing) existing.count++;
     else colors.set(color.key, {...color,count:1});
    });
   });
   this.choices.replaceChildren();
   Array.from(colors.values()).sort((a,b) => b.count-a.count || a.key.localeCompare(b.key,'he')).forEach(color => {
    const link = document.createElement('a');
    link.href = this.colorUrl(this.selection === color.key ? '' : color.key).href;
    link.className = 'bf-colors__choice';
    if (this.selection === color.key) link.setAttribute('aria-current', 'true');
    const dot = document.createElement('span'); dot.className = 'bf-colors__dot'; dot.style.background = color.background || '#eee'; dot.setAttribute('aria-hidden','true');
    const label = document.createElement('span'); label.textContent = color.key;
    const count = document.createElement('small'); count.textContent = color.count;
    link.append(dot,label,count); this.choices.append(link);
   });
   this.status.textContent = colors.size ? '' : this.dataset.noColors || '';
   if (this.selection) {
    const clear = document.createElement('a'); clear.href = this.colorUrl('').href; clear.className = 'bf-colors__clear'; clear.textContent = this.dataset.clear; this.choices.append(clear);
   }
  }
  apply(complete) {
   if (!this.grid) { if (this.resultStatus) this.resultStatus.textContent = this.dataset.empty; return; }
   let count = 0;
   this.cards.forEach(entry => {
    const matches = entry.colors.find(color => color.key === this.selection);
    entry.card.hidden = !matches;
    if (matches) {
     count++;
     entry.card.querySelectorAll('.flamengo-card__title,.flamengo-collection-gallery__slide').forEach(link => {
      const url = new URL(link.getAttribute('href'),this.url); url.searchParams.set('variant', matches.variant); link.href = url.href;
     });
     const options = entry.card.querySelectorAll('select[name="id"] option[value]');
     const ids = new Set(entry.colors.filter(color => color.key === this.selection).map(color => String(color.variant)));
     options.forEach(option => { if(option.value) option.disabled = !ids.has(option.value); });
    }
    if (complete && !this.grid.contains(entry.card)) this.grid.append(entry.card);
    if (matches && matches.image) requestAnimationFrame(() => {
      const slide = entry.card.querySelector('[data-gallery-image="' + matches.image + '"]');
      const track = entry.card.querySelector('[data-gallery-track]');
      if (slide && track) track.scrollTo({left:Array.from(track.children).indexOf(slide)*track.clientWidth, behavior:'instant'});
    });
   });
   if (complete) {
    const continuation = this.root.querySelector('[data-collection-continuation]'); if (continuation) continuation.remove();
    this.root.querySelectorAll('.flamengo-collection-pro__toolbar-count,.flamengo-collection-pro__count').forEach(node => {node.textContent=this.dataset.count.replace('[count]',count);});
    this.resultStatus.textContent = count ? '' : this.dataset.empty;
   }
  }
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-mega-menu"] && !Shopify.designMode) return;
  try {
    function initFlamengoDesktopNavigation() {
    document.querySelectorAll('.flamengo-header-nav').forEach((navigation) => {
      if (navigation.dataset.flamengoReady) return;
      navigation.dataset.flamengoReady = 'true';
      const panels = [...navigation.querySelectorAll('.flamengo-mega-menu')];
      const close = (panel) => {
        panel.open = false;
        panel.querySelector('summary').setAttribute('aria-expanded', 'false');
      };
      panels.forEach((panel) => {
        panel.addEventListener('toggle', () => {
          panel.querySelector('summary').setAttribute('aria-expanded', String(panel.open));
          if (panel.open) panels.filter((other) => other !== panel).forEach(close);
        });
        panel.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') { close(panel); panel.querySelector('summary').focus(); }
        });
      });
      document.addEventListener('pointerdown', (event) => {
        if (!navigation.contains(event.target)) panels.forEach(close);
      });
    });
  }
  initFlamengoDesktopNavigation();
  document.addEventListener('shopify:section:load', initFlamengoDesktopNavigation);
  } catch(e) { console.error(e); }
})();

})();
